const customerTypes = ['demo', 'test', 'customer', 'trial']

export default customerTypes
